import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'storfox-snackbar'
import { useNavigate } from 'react-router-dom'

import { DashboardLayout } from '~/components/Layouts'
import * as NAV from '~/constants/nav-titles'
import * as ROUTES from '~/constants/routes'

import { useDeliveryMethodCreate } from '../../hooks/DeliveryMethod'
import DeliveryMethodCreateForm from '../../components/DeliveryMethod/DeliveryMethodCreate'

function DeliveryMethodCreateContainer () {
  const { t } = useTranslation()
  const deliveryMethodCreate = useDeliveryMethodCreate()
  const snackbar = useSnackbar()
  const navigate = useNavigate()

  const title = t('New delivery method')
  const message = t('Successfully created')

  const handleSubmit = formValues => {
    return deliveryMethodCreate.create(formValues)
      .then(() => snackbar({ message }))
      .then(() => navigate(ROUTES.DELIVERY_METHOD_LIST_PATH))
  }

  const breadcrumbs = { title }

  return (
    <DashboardLayout
      title={title}
      activeNav={NAV.CONFIGURATION}
      breadcrumbs={breadcrumbs}
    >
      <DeliveryMethodCreateForm
        pageTitle={title}
        isLoading={deliveryMethodCreate.isLoading}
        onSubmit={handleSubmit}
      />
    </DashboardLayout>
  )
}

export default DeliveryMethodCreateContainer
